import store from '@/store'
import axios from 'axios'
import session from './session'
import config from '@/utils/config'
import { promotersConfig } from 'profiles/eurobits/selectors/SupportConfiguration'

export const AUTHORIZATION_SUPPORT_HEADER = 'SUPPORT'

export const HEADERS_BACK = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Authorization': 'SUPPORT'
}

export const HEADERS_API_LOGIN = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

/**
 * Performs a login as support user
 * @param {*} authorizationBody Request body
 * @param {*} impersonateUsername User to replace
 * @param {*} environment Environment to access
 * @return {Promise} Login as support user
 */
export const supportAuthorizationLoginService = (authorizationBody, impersonateUsername, environment) => {
  let url = getUrl(authorizationBody.promoterCode, environment)
  let data = {
    grant_type: 'support',
    nif: authorizationBody.nif,
    promoterCode: authorizationBody.promoterCode,
    impersonateUsername: impersonateUsername || undefined
  }
  let auth = {
    username: authorizationBody.username,
    password: authorizationBody.password
  }
  console.log('API LOGIN SERVICE', HEADERS_API_LOGIN, url, data, auth)
  return callAxiosLogin(HEADERS_API_LOGIN, url, data, auth)
}

/**
 * Refresh support user session
 * @return {Promise} Request to refresh session
 */
export const supportAuthorizationRefreshService = () => {
  let url = getUrl(config.promoterCode, session.getValue('environment'))
  let data = {
    grant_type: 'refresh_token',
    refresh_token: session.getRefreshToken()
  }
  let auth = {
    username: session.getSecValue('supportUser'),
    password: session.getSecValue('supportPass')
  }
  console.log('API LOGIN REFRESH SERVICE', HEADERS_API_LOGIN, url, data, auth, 'otros', config.promoterCode, session.getValue('environment'))
  return callAxiosLogin(HEADERS_API_LOGIN, url, data, auth).then(response => {
    session.saveSupport(response.data)
    return response.data
  })
}

/**
 * Performs a request as support to enable backend access
 * @param {*} authorizationBody Request body
 * @param {*} environment Environment to fetch
 * @return {Promise} Request
 */
export const supportAuthorizationBackService = (authorizationBody, environment) => {
  let url = getUrl(authorizationBody.promoterCode, environment)
  let data = {
    user: authorizationBody.username,
    password: authorizationBody.password,
    impersonateId: authorizationBody.nif,
    promoterCode: authorizationBody.promoterCode
  }
  console.log('BACK SERVICE', HEADERS_BACK, url, data)
  return callAxiosLogin(HEADERS_BACK, url, data)
}

/**
 * Performs a service request
 * @param {*} headers Request headers
 * @param {*} url     To fetch
 * @param {*} data    To send
 * @param {*} auth    Authorization data
 * @return {Promise}  Request
 */
function callAxiosLogin(headers, url, data, auth = undefined) {
  return axios.post(
    url,
    data,
    {
      headers: headers,
      auth: auth || undefined
    }
  ).then((res) => {
    return res
  }, (err) => {
    console.log('error en la respuesta API LOGIN:', err)
    if (err.response && err.response.data) {
      if (err.response.data.httpCode === 300) {
        return err.response.data
      }
      let msg = err.response.data.description
      let code = err.response.data.code
      if (code) msg = `${msg} (Código de error: ${code})`
      store.dispatch('errors/addServerError', { msg })
    }
    return Promise.reject(err)
  })
}

/**
 * Determines the URL to be fetched
 * @param {*} promoterCode  Customization code
 * @param {*} environment   To fetch
 * @return {String} URL
 */
function getUrl(promoterCode, environment) {
  let configuration = promotersConfig.filter(item => (item.id === promoterCode))[0]
  if (environment === 'PRE') {
    if (configuration.loginType === 'BACK') {
      return 'http://sfe-pre-docker-01.eurobits.local:8000/eurobits/token'
    } else {
      return 'http://sfe-pre-docker-01.eurobits.local:9095/oauth/token'
    }
  } else {
    if (configuration.loginType === 'BACK') {
      return 'https://sferest.sistemaefactura.com/eurobits/token'
    } else {
      return 'https://login-api.sistemaefactura.com/oauth/token'
    }
  }
}
